import { ListingAutoPricingSettingsFormContentWrapper } from 'src/modals/ListingDetails/ListingForms/AutoPricingForm/components/ListingAutoPricingSettingsFormContentWrapper/ListingAutoPricingSettingsFormContentWrapper';

export const AutoPricingSettings = ({
  isLoading,
  hasParents,
  isGlobalEdit,
}: {
  isLoading?: boolean;
  hasParents?: boolean;
  isGlobalEdit?: boolean;
}) => {
  return (
    <ListingAutoPricingSettingsFormContentWrapper
      listing={undefined}
      disabled={isLoading ?? false}
      isBulkEdit
      isGlobalEdit={isGlobalEdit}
    />
  );
};
